export default "__VITE_ASSET__BL18PWqr__"